import { render, staticRenderFns } from "./PlusStarsIcon.vue?vue&type=template&id=527aae57&scoped=true&"
import script from "./PlusStarsIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PlusStarsIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527aae57",
  null
  
)

export default component.exports